var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "50px",
    height: "50px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.12,5.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.72266,10c-7.162,0 -7.72266,0.56066 -7.72266,7.72266v14.55469c0,7.162 0.56066,7.72266 7.72266,7.72266h14.55469c7.162,0 7.72266,-0.56066 7.72266,-7.72266v-14.50781c0,-7.206 -0.56353,-7.76953 -7.76953,-7.76953zM17,11h16c5.565,0 6,0.435 6,6v16c0,5.565 -0.435,6 -6,6h-3.28711v-9.64453h3.74023l0.56055,-4.46094h-4.29883v-3.12305c0,-1.237 0.83466,-1.87109 1.72266,-1.87109c0.888,0 2.72656,-0.02539 2.72656,-0.02539v-3.99023c0,0 -1.63564,-0.18945 -3.30664,-0.18945c-1.404,0 -2.9495,0.39592 -4.1875,1.66992c-1.259,1.295 -1.44141,3.20702 -1.44141,5.54102v1.99023h-3.75v4.46094h3.75v9.64258h-8.22852c-5.565,0 -6,-0.435 -6,-6v-16c0,-5.565 0.435,-6 6,-6z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebookIcon.a4581a1efeaf1b51982254013ed4cad5.svg";
export { ForwardRef as ReactComponent };